export const MAX_AMOUNT_OF_ONBOARDING_STEPS = 5
export const VALID_STORE_GRID_TYPES = ['default', 'rows', 'playful']
export const FALLBACK_AVATAR_IMAGE = '/img/default_profilepicture.jpg'
export const FALLBACK_HEADER_IMAGE = '/img/default_headerimage.jpg'
export const FALLBACK_PRODUCT_IMAGE = {
  nl: '/img/fallback_image_product_nl.jpg',
  en: '/img/fallback_image_product_en.jpg',
}
